module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.fileNum == 1) ? _c('div', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/api/uploads",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.handleBeforeAvatarUpload
    }
  }, [(_vm.fileUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.fileUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1) : _c('div', [_c('el-upload', {
    attrs: {
      "action": "/api/uploads",
      "list-type": "picture-card",
      "file-list": _vm.imgList,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.handleBeforeAvatarUpload,
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.handleRemove,
      "disabled": _vm.disabled
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-7bfb6210","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/Upload.vue
// module id = 870
// module chunks = 0